import Vue from 'vue'

import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n

import '@/assets/styles/element-variables.scss'
import '@/assets/styles/index.scss' // global cs

import App from './App'
import router from './router'
import store from './store'

import '@/permission' // permission control
import 'default-passive-events' //监听鼠标滚轮事件

import '@/static/iconfont.css'

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
Vue.use(ElementUI, { locale })

Vue.config.productionTip = false

// 全局组件
import plugins from './components/index'
Vue.use(plugins);

// common
import common from '@/utils/common'
Vue.prototype.$common = common
import { Message } from 'element-ui'
Vue.prototype.$Message = Message

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js